import * as Api from "@api";
import * as C from "@components";
import clsx from "clsx";
import css from "./pro-vape-tips.module.scss";

export const ProVapeTipsContentKeys = [
    "pro-vape-tips.body",
    "pro-vape-tips.tip.1.body",
    "pro-vape-tips.tip.2.body",
    "pro-vape-tips.tip.3.body",
] as const;

interface ProVapeTipsProps
{
    imageDirectory: string;
    pageContent: Api.Content<typeof ProVapeTipsContentKeys[number]>;
}

export const ProVapeTips = ({ imageDirectory, pageContent }: ProVapeTipsProps): React.FunctionComponentElement<ProVapeTipsProps> =>
{
    return (
        <C.Card className={css["card"]} layout={{ all: { paddings: { all: C.Padding.D24 }, variant: C.CardVariant.CenteredContent, width: C.Width.W100P }, ipad: { paddings: { y: C.Padding.D86 } } }} useWrapper>
            <div>
                <C.PageContent {...pageContent["pro-vape-tips.body"]} typography={C.Typography.H6} margins={{ y: C.Margin.D40 }} />

                <C.Container horizontalGap={70} className={css['bottom-container']}>
                    <C.CaptionedImage imageProps={{ src: `${imageDirectory}pro-1.webp`, width: 260, height: 300, alt: "Low" }} leftAligned>
                        <div className={clsx(C.maxWidthClass(C.Width.W260), C.marginsClass({ top: C.Margin.D10 }), css['bottom-container-item-labels'])}>
                            <C.PageContent {...pageContent["pro-vape-tips.tip.1.body"]} typography={C.Typography.P2} />
                        </div>
                    </C.CaptionedImage>
                    <C.CaptionedImage imageProps={{ src: `${imageDirectory}pro-2.webp`, width: 260, height: 300, alt: "Medium" }} leftAligned>
                        <div className={clsx(C.maxWidthClass(C.Width.W260), C.marginsClass({ top: C.Margin.D10 }), css['bottom-container-item-labels'])}>
                            <C.PageContent {...pageContent["pro-vape-tips.tip.2.body"]} typography={C.Typography.P2} />
                        </div>
                    </C.CaptionedImage>
                    <C.CaptionedImage imageProps={{ src: `${imageDirectory}pro-3-updated.png`, width: 260, height: 300, alt: "High" }} leftAligned>
                        <div className={clsx(C.maxWidthClass(C.Width.W260), C.marginsClass({ top: C.Margin.D10 }), css['bottom-container-item-labels'])}>
                            <C.PageContent {...pageContent["pro-vape-tips.tip.3.body"]} typography={C.Typography.P2} />
                        </div>
                    </C.CaptionedImage>
                </C.Container>
            </div>
        </C.Card>
    )
}

// TODO: Implement key interpolation.